module.exports = __webpack_public_path__ + "static/img/login.6ab07765.jpg";